import keyMirror from 'keymirror';

export default keyMirror({
  AUTH: null,
  GET_TEST: null,
  GET_PROBLEMS: null,
  GET_TEST_SOLUTIONSET: null,
  GET_API_V1_TEST_SOLUTIONSET: null,
  GET_SECTIONS: null,
  GET_PROBLEM_SOLUTION: null,
  GET_DESMOND_PROBLEM_SOLUTION: null,
  GET_HACKER: null,
  GET_INVITE: null,
  TRY_TEST_RECRUITER: null,
  INIT_TEST: null,
  START_TEST: null,
  WAIT_TILL_VIDEO_SUBMIT: null,
  PROGRESS_START: null,
  PROGRESS_STOP: null,
  APP_OFFLINE: null,
  APP_ONLINE: null,
  APP_RECONNECTING: null,
  /*
  Todo:
    1. Action `SAVE_SOLUTION_NO_DEBOUNCE` is used in MCQ container src/components/ProblemTypes/MultipleChoice.js
    rename to `SAVE_MCQ_SOLUTION`
    2. Action `SAVE_SOLUTION` is used in SUB container
      src/components/Solution/Solution.js rename to `SAVE_SUBJECTIVE_SOLUTION`
*/
  SAVE_SOLUTION: null,
  SAVE_CLUSTER_SOLUTION: null,
  SAVE_SOLUTION_NO_DEBOUNCE: null,
  CREATE_OR_UPDATE_VIDEO_SOLUTION: null,
  CREATE_OR_UPDATE_AUDIO_SOLUTION: null,
  SET_SAVE_IN_PROGRESS: null,
  SHOW_TOAST: null,
  HIDE_TOAST: null,
  SUBMIT_TEST: null,
  GET_BOOKMARKS: null,
  SET_BOOKMARK: null,
  SET_PROBLEMS_GROUP: null,
  SUBMIT_SECTION: null,
  CONTINUE_TEST: null,
  SET_ATTEMPTS_COUNT: null,
  SET_CLUSTER_ATTEMPTS_COUNT: null,
  SUBMIT_FEEDBACK: null,
  GET_FEEDBACK: null,
  GET_USER_TYPE: null,
  GET_RECRUITER: null,
  SHOW_SYSTEM_CHECK: null,
  HIDE_SYSTEM_CHECK: null,
  ENABLE_WEBCAM: null,
  DISABLE_WEBCAM: null,
  ALLOW_WEBCAM_PERMISSION: null,
  DENY_WEBCAM_PERMISSION: null,
  SET_WEBCAM_EXCEPTION: null,
  INITIATE_WEBSOCKET_CONNECTION: null,
  SOCKET_FETCH_SETTINGS: null,
  SOCKET_CONNECTED: null,
  SOCKET_DISCONNECTED: null,
  DISCONNECT_SOCKET: null,
  INITIALIZING_SOCKET: null,
  ENABLE_SNAPSHOT_INTERVAL: null,
  DISABLE_SNAPSHOT_INTERVAL: null,
  UPLOAD_SNAPSHOT: null,
  VIDEO_UPLOAD: null,
  AUDIO_UPLOAD: null,
  GET_IDENTITY_DEATILS: null,
  HAS_IDENTITY_IMAGE: null,
  UPLOAD_IDENTITY_IMAGE: null,
  UPLOAD_FAILED_PROCTOR_IMAGES: null,
  VERIFYING_IDENTITY_IMAGE: null,
  HAS_IDPROOF_IMAGE: null,
  UPLOAD_IDPROOF_IMAGE: null,
  VERIFYING_IDPROOF_IMAGE: null,
  UPLOAD_AUDIO_SAMPLE: null,
  RETAKE_AUDIO_SAMPLE: null,
  // VERIFYING_AUDIO_SAMPLE: null,
  RETAKE_IDPROOF_SNAPSHOT: null,
  ENABLE_FULLSCREEN: null,
  DISABLE_FULLSCREEN: null,
  EMIT_WEBCAM_EVENT: null,
  ENABLE_VISIBILITY: null,
  DISABLE_VISIBILITY: null,
  SHOW_BROWSER_TOLERANCE_MODAL: null,
  HIDE_BROWSER_TOLERANCE_MODAL: null,
  INITILIZE_BROWSER_TOLERANCE: null,
  DECREMENT_BROWSER_TOLERANCE_COUNT: null,
  UPLOAD_ATTACHMENT_PROB: null,
  SET_FINGERPRINT: null,
  SHOW_MULTI_SESSION_PROMPT: null,
  TRACK_SOCKET_CONNECTION_ERROR: null,
  TRACK_SOCKET_ERROR: null,
  TRACK_SOCKET_DISCONNECTED: null,
  TRACK_TEST_START: null,
  TRACK_FINISH_TEST: null,
  TRACK_SUBMIT_SECTION: null,
  TRACK_WINDOW_FOCUS: null,
  TRACK_WINDOW_BLUR: null,
  TRACK_ROUTE_CHANGE: null,
  CAPTURE_SCREEN_EVENT: null,
  MONITOR_SESSION: null,
  CUSTOM_FORM_UPLOAD_FILE: null,
  SUBMIT_CUSTOM_FORM: null,
  GET_REPORT_SOLUTIONSET: null,
  RETAKE_TEST: null,
  GET_REPORT_SOLUTION: null,
  GET_SERVER_TIME_AND_TRACKING_ID: null,
  REPORT_ISSUE: null,
  SHOW_REPORT_ISSUE: null,
  HIDE_REPORT_ISSUE: null,
  ENABLE_SINGLE_PROBLEM_VIEW: null,
  DISABLE_SINGLE_PROBLEM_VIEW: null,
  SET_TIMER: null,
  CLEAR_LOCAL_DATA: null,
  TOGGLE_REPORT_QUALITY_ANNOTATION: null,
  CHECK_URL_FOR_IFRAME: null,
  CLEAR_URL_FOR_IFRAME_DATA: null,
  /**
   * Coding problem actions - START
   */
  SETUP_CODING_ENVIRONMENT: null,
  SET_CODING_PROBLEM_DATA: null,
  GET_LANGUAGE_STUB: null,
  SWITCH_EDITOR_THEME: null,
  SET_DEFAULT_LANGUAGE: null,
  SAVE_CODING_PROBLEM: null,
  CHANGE_LANGUAGE: null,
  SET_INIT_CODE_IN_SOLUTION: null,
  SET_LIBRARY_LOADED_SUCCESS: null,
  SET_CODING_CUSTOM_INPUT: null,
  RUN_CODE_CUSTOM_INPUT: null,
  RUN_CODE_CUSTOM_INPUT_RESULT: null,
  RUN_CODE_TEST_CASES: null,
  RUN_CODE_TEST_CASES_RESULT: null,
  RESET_RUN_CODE_DATA: null,
  RESET_PROBLEM_DATA: null,
  ABORT_RUN_CODE: null,
  AUTO_ABORT_RUN_CODE: null,
  ON_CODE_CHANGE: null,
  GET_TECHNOLOGIES: null,
  SAVE_CODE_NO_DEBOUNCE: null,
  /**
   * Coding problem actions - END
   */
  CLEAR_SOLUTION: null,

  SHOW_PREPARING_ASSESSMENT_MODAL: null,
  HIDE_PREPARING_ASSESSMENT_MODAL: null,
  STORE_FAILED_EVENTS: null,
  EMIT_FAILED_EVENTS_TO_SOCKET: null,
  FAILED_SOCKET_EVENTS_STATUS: null,
  SET_PROCTORING_AB_ENABLED: null,
  SET_PROCTOR_BATCH_AB_ENABLED: null,
  SET_FAILED_PROCTOR_IMAGE_COUNTER: null,
  UPDATE_PROCTORING_SIGNED_URLS: null,
  REMOVE_PROCTORING_SIGNED_URL: null,
  UPDATE_SIGNED_URL_BATCH_SIZE: null,
  SET_REALTIME_PROCTORING_FEEDBACK_ENABLED: null,
  SET_PROCTOR_IS_TEST_SUBMITTED: null,
  SHOW_AUTO_SUBMIT_MODAL: null,
  HIDE_AUTO_SUBMIT_MODAL: null,
  INCREMENT_FAILED_PROCTOR_IMAGE_COUNTER: null,
  GET_ACTIVE_SESSION: null,
  CREATE_ACTIVE_SESSION: null,
  SET_ACTIVE_SESSION: null,
  SET_NEXT_PROCTOR_IMAGE_SEQUENCE: null,
  SET_PROCTOR_SESSION_ID: null,
  SET_PROCTOR_TAB_ID: null,
  IDE_CONTAINER_ACTION: null,
  RUN_DESMOND_TYPE_TEST_CASES: null,
  SET_DESMOND_PROBLEM_DATA: null,
  DESMOND_PROBLEM_EVALUATE: null,
  RESET_RUN_DESMOND_DATA: null,
  DESMOND_PROBLEM_REPO: null,
  DESMOND_PROBLEM_SAVE_REPO: null,
  SET_AUTO_SUBMIT_REASON: null,
  EMIT_WEBSOCKET_EVENT: null,
  EVALUATE_WEBSOCKET_BROWSER_TOLERANCE_COUNT: null,
  REMOVE_PROBLEM_SOLUTION: null,
  SET_TEST_QUERY: null,
  CHECK_ENV_SETUP_STATUS: null,
  CHECK_DJP_PROBLEM_IN_TEST_AND_SETUP: null,
  INIT_PLAYGROUND: null,
  SAVE_PLAYGROUND_SOLUTION: null,
  IS_POD_BASED_PROBLEM: null,
  INCREMENT_ENV_SETUP_RETRY: null,
  GET_ALL_REVISIONS: null,
  SUBMIT_AND_EVALUATE_FBE: null,
  UPADTE_TEST_EXPIRY_AND_TEST_SESSION: null,
  SET_TEST_SUBMIT_IN_PROCESS: null,
  SET_TEST_END_TIME: null,
  GET_PROBLEM_BY_SLUG: null,
  SETUP_JUPYTER_ENV_PLAYGROUND: null,
  GET_SERVER_STATUS: null,
  SET_JUPYTER_ENV_DATA: null,
  CHECK_INFRA_ALLOCATION: null,
  RUN_DESMOND_CODE_CUSTOM_INPUT: null,
  RUN_PROJECT: null,
  RUN_VERIFY_TEST_CASES_RESULT: null,
  GET_POD_BASED_EVALUATION_DETAILS: null,
  GET_POD_BASED_CURRENT_EVALUATION_ID: null,
  RUN_POD_BASED_TEST_PROJECT: null,
  SET_POD_BASED_EVALUATION_STATE: null,
  SET_POD_BASED_TESTPROJECTSTATES: null,
  GET_POD_BASED_EVALUATION_LOG: null,
  GET_TEST_PROJECT_DISABLED_SLUGS: null,
  INITIATE_POD_BASED_EVALUATION: null,
  RESET_IS_LOG_CONTENT_LENGTH_AVAILABLE: null,
  SET_VIDEO_UPLOAD_STATUS: null,
  SET_VIDEO_UPLOAD_FAILED: null,
  SET_AUDIO_UPLOAD_STATUS: null,
  SLUG_CHANGE_FROM_ROUTER: null,
  SET_TEST_SUBMITTING: null,
  LEAVE_TEST_VIOLATION: null,
  MULTI_SESSION_ACTIVE: null,
  SET_CURRENTLY_PLAYING_AUDIO_PROLEM_SLUG: null,
  SET_AUDIO_PLAY_COUNT: null,
  SET_TEST_LIVE_STATUS: null,
  INDEX_PROBLEMS: null,
  SECURE_BROWSER_STATUS: null,
  POD_HEALTH_CHECK: null,
  SECURE_BROWSER_SYSTEM_CHECK: null,
  RECHECK_SYSTEM_REQ: null,
  GET_WHITELABEL_COMPANY_DATA: null,
  GET_INTERVIEW_SESSION: null,
  GET_INTERVIEW_SESSION_SUCCESS: null,
  GET_INTERVIEW_SESSION_FAIL: null,
  VALIDATE_DHWANI_INTERVIEW_SESSION: null,
  VALIDATE_DHWANI_INTERVIEW_SESSION_SUCCESS: null,
  VALIDATE_DHWANI_INTERVIEW_SESSION_FAIL: null,
  VALIDATE_DHWANI_INTERVIEW_SESSION_RESET: null,
  UPLOAD_CANDIDATE_CV: null,
  UPLOAD_CANDIDATE_CV_SUCCESS: null,
  UPLOAD_CANDIDATE_CV_FAIL: null,
  CV_GENERATION_STATUS: null,
  CV_GENERATION_STATUS_SUCCESS: null,
  CV_GENERATION_STATUS_FAIL: null,
  CV_UPLOAD_STATUS: null,
  CV_UPLOAD_STATUS_SUCCESS: null,
  CV_UPLOAD_STATUS_FAIL: null,
  // Audio proctoring (VAD) signed URL + upload
  GET_AUDIO_PROCTOR_SIGNED_URL: null,
  GET_AUDIO_PROCTOR_SIGNED_URL_SUCCESS: null,
  GET_AUDIO_PROCTOR_SIGNED_URL_FAIL: null,
  UPLOAD_AUDIO_PROCTOR_SEGMENT: null,
  UPLOAD_AUDIO_PROCTOR_SEGMENT_SUCCESS: null,
  UPLOAD_AUDIO_PROCTOR_SEGMENT_FAIL: null,
  PROCESS_AUDIO_PROCTOR_INCIDENT: null,
  SET_VAD_BLOCKING_PROBLEM_TYPE: null,
});
